import { DELETE_SCOPE } from '../util';
import { useUserScopes } from './useUserScopes';

export interface DeleteScope {
	canDelete: boolean;
	isLoading: boolean;
}

export function useDeleteScope(): DeleteScope {
	const { scopes, isLoading } = useUserScopes();
	return { canDelete: scopes.includes(DELETE_SCOPE), isLoading };
}

export function useCanDelete(): boolean {
	return useDeleteScope().canDelete;
}
